import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { decimals: { type: Number, default: 2 } }

  limit(event) {
    const input = event.target
    const value = input.value
    if (value === "" || !value.includes(".")) return

    const [whole, fraction] = value.split(".")
    if (fraction.length <= this.decimalsValue) return

    input.value = `${whole}.${fraction.slice(0, this.decimalsValue)}`
  }
}
